import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { addToast } from 'containers/Toasts/actions'

import {
  assignToCompaniesError,
  assignToCompaniesSuccess,
  fetchCompaniesDataError,
  fetchCompaniesDataSuccess,
} from './actions'
import {
  ASSIGN_REQUEST_ASYNC,
  ASSIGNED_FILTER_CHANGE,
  COMPANIES_DATA_REQUEST_ASYNC,
  FILTERS_SUBMIT,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SORT_PROPERTY_CHANGE,
} from './constants'

const fetchCompaniesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      COMPANIES_DATA_REQUEST_ASYNC.INITIATE,
      ASSIGN_REQUEST_ASYNC.SUCCESS,
      SORT_PROPERTY_CHANGE,
      FILTERS_SUBMIT,
      ASSIGNED_FILTER_CHANGE,
      PAGINATE_CHANGE,
      SEARCH_CHANGE
    )
    .mergeMap(() =>
      api.groupSettings
        .getGroupSettingsCompanies(
          store.getState().groupsettings.assign.groupSettings?.id,
          store.getState().groupsettings.assign.page,
          store.getState().groupsettings.assign.sortProperty,
          store.getState().groupsettings.assign.filters?.emailIntegrationFilter,
          store.getState().groupsettings.assign.filters?.groupSettingsFilter,
          store.getState().groupsettings.assign.filters?.assignedFilter,
          store.getState().groupsettings.assign.search,
          store.getState().partnerOptions.selectedCompany?.value
        )
        .map((response) => fetchCompaniesDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchCompaniesDataError, error)))
        .takeUntil(action$.ofType(COMPANIES_DATA_REQUEST_ASYNC.CANCEL))
    )

const assignGroupSettingsToCompaniesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(ASSIGN_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.groupSettings
      .assignGroupSettingsToCompanies(store.getState().partnerOptions.selectedCompany?.value, {
        groupSettingsId: store.getState().groupsettings.assign.groupSettings?.id,
        companiesList: Object.keys(store.getState().groupsettings.assign.selectedCompaniesMap),
        selectAll: store.getState().groupsettings.assign.selectAll,
        search: store.getState().groupsettings.assign.search,
        emailIntegrationFilter:
          store.getState().groupsettings.assign.filters?.emailIntegrationFilter,
        groupSettingsFilter: store.getState().groupsettings.assign.filters?.groupSettingsFilter,
        assignedFilter: store.getState().groupsettings.assign.filters?.assignedFilter,
      })
      .map((response) => assignToCompaniesSuccess(response))
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(assignToCompaniesError, error),
          addToast({
            message: error.response?.message || error?.response,
            type: 'error',
          })
        )
      )
      .takeUntil(action$.ofType(ASSIGN_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(assignGroupSettingsToCompaniesEpic, fetchCompaniesEpic)
